module.exports = "<p>\n  exams-course-edit works!\n</p>\n"